import { FC, useCallback } from 'react'
import * as styles from 'styles/molecules/PopularProviders.css'
import ProviderBadge from 'components/unorganized/ProviderBadge'
import { startLinkageSessionActionCreator } from 'actions/linkageActions'
import { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { popularProvidersSelector } from 'selectors/linkageSelectors'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { popularProvidersGuard } from 'guards/popularProviders'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'

export const PopularProviders: FC<{}> = () => {
  const dispatch = useStoreDispatch()
  const isLoaded = useSimpleGuard(popularProvidersGuard, [], 'Account Linkage Pane')
  const providers = useStoreSelector(popularProvidersSelector)

  const handleClick = useCallback((provider) => {
    if (provider.fast_link_forced) {
      return dispatch(new ModifyFloatingPaneAction({
        type: 'fastlink',
        mode: 'add',
        provider_id: provider.id,
      }))
    }
    return dispatch(startLinkageSessionActionCreator.request(provider))
  }, [dispatch])

  const getProviderChild = useCallback((provider) => !!provider && (
    <div
      key={ provider.id }
      className={ styles.popularAccountListItem }
      onClick={ () => handleClick(provider) }
    >
      <ProviderBadge { ...provider } />
    </div>
  ), [handleClick])

  if (!isLoaded || !providers) {
    return <LoadingOverlay />
  }

  return (
    <section className={ styles.popularProviders } data-qa-marker='popular-providers'>
      { providers.map(getProviderChild) }
    </section>
  )
}

export default PopularProviders
